import { forwardRef } from 'react';

const Text = forwardRef((props, ref) => {
  const { paragraph, ...textProps } = props;
  const TextComponent = paragraph ? 'p' : 'span';
  return <TextComponent {...textProps} ref={ref} />;
});

export default Text;
